import { FC } from 'react';
import { Loader } from '@new/common/ui/Loader/Loader';
import { PageHeader } from '@new/common/ui/PageHeader/PageHeader';
import {
  ProjectsReviewProvider,
  useProjectsReview,
  SEARCH_MODE_OPTIONS,
} from '../contexts/ProjectsReviewProvider';
import { ProjectsTable } from './ProjectsTable/ProjectsTable';
import { ProjectsDrawer } from './ProjectsDrawer/ProjectsDrawer';
import { ProjectsFilters } from './ProjectsFilters/ProjectsFilters';
import { ProjectsDateFilter } from './ProjectsDateFilter/ProjectsDateFilter';
import { SearchBar } from '@new/common/ui/SearchBar/SearchBar';

const ProjectsReviewContent: FC = () => {
  const {
    isLoading,
    selectedProject,
    setSelectedProjectId,
    searchQuery,
    setSearchQuery,
    searchMode,
    setSearchMode,
  } = useProjectsReview();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="sm:px-6 lg:px-8 py-8 flex flex-col gap-8">
        <PageHeader
          title="Projects Review"
          description="Review and grade student project submissions"
        />

        <section className="bg-(--neutral-white-NW1000) rounded-xl border border-(--neutral-white-NW800) shadow-sm overflow-hidden">
          <div className="flex flex-col gap-3 px-4 sm:px-6 py-4 border-b border-(--neutral-white-NW800)">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
              <SearchBar
                options={SEARCH_MODE_OPTIONS}
                value={searchMode}
                onChange={setSearchMode}
                searchQuery={searchQuery}
                onSearchQueryChange={setSearchQuery}
              />
              <ProjectsDateFilter />
            </div>

            <ProjectsFilters />
          </div>

          <ProjectsTable />
        </section>

        <ProjectsDrawer
          selectedProject={selectedProject}
          setSelectedProjectId={setSelectedProjectId}
        />
      </div>
    </div>
  );
};

export const ProjectsReview: FC = () => (
  <ProjectsReviewProvider>
    <ProjectsReviewContent />
  </ProjectsReviewProvider>
);
